import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTable, faTh, faTags, faListUl, faPlusSquare, faMinusSquare, faGlobe } from '@fortawesome/free-solid-svg-icons';

class CategoryBlock extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      categories: [],
      categoriesToShow: [],
      loading: true,
      error: null,
    };
  }

  componentDidMount() {
    this.fetchAllCategoryData();
  }

  fetchAllCategoryData() {
    const { config } = this.props;
    const apiUrl = `${config.PY_API_URL}category`;

    fetch(apiUrl)
      .then(response => response.json())
      .then((data) => {
        if (data.status === 'success') {
          const filteredCategories = this.filterCategories(data.data, config.relation, config.categoryCode);
          this.setState({ categoriesToShow: filteredCategories });
          this.setState({ categories: data.data, loading: false });
      
        } else {
          this.setState({ loading: false, error: data.message });
        }
      })
      .catch(error => {
        console.error('Error fetching category data:', error);
        this.setState({ loading: false, error: 'Error fetching data' });
      });
  }

  filterCategories(categories, relation, categoryCode) {
    if (!categoryCode) {
      return categories;
    }
    let filSelectedcat = categories.filter(category => category.category_code === categoryCode);
    if (!filSelectedcat[0]) {
      return categories;
    }
    let selectedcat = filSelectedcat[0];
    switch (relation) {
      case 'children':
        return categories.filter(category => category.parent_category_id === selectedcat.id);
      case 'siblings':
        const parent = categories.find(category => category.id === selectedcat.id)?.parent_category_id;
        return categories.filter(category => category.parent_category_id === parent);
      case 'children-all':
        return categories.filter(category => {
          let currentCategory = category;
          while (currentCategory) {
            if (currentCategory.parent_category_id === selectedcat.id) return true;
            currentCategory = categories.find(c => c.id === currentCategory.parent_category_id);
          }
          return false;
        });
      case 'parents':
        return categories.filter(category => category.id === selectedcat.id);
      case 'parents-all':
        const parentCategories = [];
        let currentCategory = categories.find(category => category.id === selectedcat.id);
        while (currentCategory) {
          parentCategories.push(currentCategory);
          currentCategory = categories.find(category => category.id === currentCategory.parent_category_id);
        }
        return parentCategories;
      case 'all':
      default:
        return categories;
    }
  }

  renderCategoryTable(categories) {
    const renderCategoryRows = (parentId, level = 0) => {
      return categories
        .filter(category => category.parent_category_id === parentId)
        .map(category => (
          <React.Fragment key={category.id}>
            <tr>
              <td style={{ paddingLeft: `${level * 20}px` }}>{category.name}</td>
            </tr>
            {renderCategoryRows(category.id, level + 1)}
          </React.Fragment>
        ));
    };

    return (
      <table>
        <thead>
          <tr>
            <th>Category</th>
          </tr>
        </thead>
        <tbody>
          {renderCategoryRows(0)}
        </tbody>
      </table>
    );
  }

  render() {
    const { categories, categoriesToShow, loading, error } = this.state;
    const { config } = this.props;

    if (loading) {
      return <p>Loading...</p>;
    }

    if (error) {
      return <p>{error}</p>;
    }

    // Example data for top gainers and losers
    const topGainers = categoriesToShow.slice(0, 3); // Replace with actual logic
    const topLosers = categoriesToShow.slice(3, 6); // Replace with actual logic

    return (
      <div>
        <TopCategoriesBlock gainers={topGainers} losers={topLosers} config={config} />
        <ChildCategories childCategories={categories} categoriesToShow={categoriesToShow} config={config} />
      </div>
    );
  }
}

const TopCategoriesBlock = ({ gainers, losers, config }) => {
  const renderCategoryItem = (category) => {
    const { name, category_code, oneYearChange, threeYearChange, fiveYearChange } = category;
    const getColor = (change) => (change >= 0 ? '#28a745' : '#f44336'); // Green for gain, red for loss

    return (
      <li key={category.id} className="category-item">
        <a href={`${config.siteUrl}/category/${category_code}`}>
          {name}
        </a>
        <div className="category-stats">
          <span style={{ color: getColor(oneYearChange) }}>1Y: {oneYearChange}%</span>
          <span style={{ color: getColor(threeYearChange) }}>3Y: {threeYearChange}%</span>
          <span style={{ color: getColor(fiveYearChange) }}>5Y: {fiveYearChange}%</span>
        </div>
      </li>
    );
  };

  return (
    <div className="top-categories-block">
      <div className="top-gainers">
        <h3>Top Gainers</h3>
        <ul>
          {gainers.map(renderCategoryItem)}
        </ul>
      </div>
      <div className="top-losers">
        <h3>Top Losers</h3>
        <ul>
          {losers.map(renderCategoryItem)}
        </ul>
      </div>
    </div>
  );
};

const ChildCategories = ({ childCategories, categoriesToShow, config }) => {
  const [expandedCategories, setExpandedCategories] = useState({});
  const [layout, setLayout] = useState(config.viewMode);

  let colWidthClass = 'elementor-col-100';

  const numChildCategories = categoriesToShow.length;
  if (numChildCategories >= 4) {
    colWidthClass = 'elementor-col-25';
  } else if (numChildCategories === 3) {
    colWidthClass = 'elementor-col-33';
  } else if (numChildCategories === 2) {
    colWidthClass = 'elementor-col-50';
  }

  let treeViewSelectedcat = childCategories.filter(category => category.category_code === config.categoryCode);
  const buildCategoryTree = (categories) => {
    let categoryMap = {};


    categories.forEach(category => {
      categoryMap[category.id] = { ...category, child_categories: [] };
    });

    let rootCategories = [];

    categories.forEach(category => {
      if (category.parent_category_id === 0 || category.parent_category_id === null) {
        rootCategories.push(categoryMap[category.id]);
      } else {
        categoryMap[category.parent_category_id]?.child_categories.push(categoryMap[category.id]);
      }
    });

    // Function to filter the category tree
    const filterCategoryTree = (category) => {
      if (category.category_code === config.categoryCode) {
          return true;
      }
      category.child_categories = category.child_categories.filter(filterCategoryTree);
      return category.child_categories.length > 0;
    };

    // Filter rootCategories if config.categoryCode is provided
    if (config.categoryCode) {
      rootCategories = rootCategories.filter(filterCategoryTree);
    }
    return rootCategories;
  };

  // const hierarchicalCategories = buildCategoryTree(treeViewSelectedcat);
  const hierarchicalCategories = buildCategoryTree(childCategories);

  const toggleCategory = (categoryId) => {
    setExpandedCategories((prevState) => ({
      ...prevState,
      [categoryId]: !prevState[categoryId],
    }));
  };

  const CategoryTree = ({ categories, categoryCode }) => {
    return (
      <ul className="tree">
        {categories.map((category) => (
          <li key={category.id}>
            <div onClick={() => toggleCategory(category.id)} style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}>
              {category.child_categories.length > 0 && (
                <FontAwesomeIcon
                  icon={expandedCategories[category.id] ? faMinusSquare : faPlusSquare}
                  style={{ marginRight: '5px' }}
                />
              )}
              <a href={`${config.siteUrl}/category/${category.category_code}`}>{category.name}</a>
            </div>
            {expandedCategories[category.id] && category.child_categories.length > 0 && (
              <CategoryTree categories={category.child_categories} />
            )}
          </li>
        ))}
      </ul>
    );
  };


  const renderCategoriesV2 = (categories, config) => {
    const categoryMap = new Map();
    const rootCategoryIds = [];
  
    // Build the category map and root category list
    categories.forEach(category => {
      const parentId = category.parent_category_id;
      if (parentId == 0 || parentId == null) {
        if (!rootCategoryIds.includes(category.id)) {
          rootCategoryIds.push(category.id);
        }
      }
      if (!categoryMap.has(parentId)) {
        categoryMap.set(parentId, []);
      }
      categoryMap.get(parentId).push(category);
    });
  
    // Create a map for category details including child categories
    const detailedCategoryMap = {};
    categories.forEach(category => {
      detailedCategoryMap[category.id] = { ...category, child_categories: [] };
    });
  
    // console.group("detailedCategoryMap", detailedCategoryMap, categories);
  
    // Build the hierarchical structure
    categories.forEach(category => {
      if (category.parent_category_id !== 0 && category.parent_category_id !== null) {
        detailedCategoryMap[category.parent_category_id]?.child_categories.push(detailedCategoryMap[category.id]);
      }
    });
  
    // Function to filter the category tree
    const filterCategoryTree = (category) => {
      if (category.category_code === config.categoryCode) {
        return true;
      }
      category.child_categories = category.child_categories.filter(filterCategoryTree);
      return category.child_categories.length > 0;
    };
  
    // Filter rootCategories if config.categoryCode is provided
    let rootCategories = rootCategoryIds.map(id => detailedCategoryMap[id]);
    if (config.categoryCode) {
      rootCategories = rootCategories.filter(filterCategoryTree);
    }
  
    const renderCategoryRows = (category) => {
      return (
        <React.Fragment key={category.id}>
          {/* <tr> */}
            <td>
              <a href={`${config.siteUrl}/category/${category.category_code}`}>
                {category.name}
              </a>
              {category.child_categories.length > 0 && (
                <table>
                  <tbody>
                    <tr>
                      {category.child_categories.map(childCategory => renderCategoryRows(childCategory))}
                    </tr>
                  </tbody>
                </table>
              )}
            </td>
          {/* </tr> */}
        </React.Fragment>
      );
    };
  
    return (
      <div>
        {rootCategories.map(rootCategory => (
          <table className="all_category category-table" key={rootCategory.id}>
            <tbody>
              <tr>
                {renderCategoryRows(rootCategory)}
              </tr>
            </tbody>
          </table>
        ))}
      </div>
    );
  };

  const renderCategories = (categories, config) => {
    const categoryMap = new Map();
    const rootCategoryIds = [];
  
    // Build the category map and root category list
    categories.forEach(category => {
      const parentId = category.parent_category_id;
      if (parentId == 0 || parentId == null) {
        if (!rootCategoryIds.includes(category.id)) {
          rootCategoryIds.push(category.id);
        }
      }
      if (!categoryMap.has(parentId)) {
        categoryMap.set(parentId, []);
      }
      categoryMap.get(parentId).push(category);
    });
  
    // Create a map for category details including child categories
    const detailedCategoryMap = {};
    categories.forEach(category => {
      detailedCategoryMap[category.id] = { ...category, child_categories: [] };
    });
  
    // Build the hierarchical structure
    categories.forEach(category => {
      if (category.parent_category_id !== 0 && category.parent_category_id !== null) {
        detailedCategoryMap[category.parent_category_id]?.child_categories.push(detailedCategoryMap[category.id]);
      }
    });
  
    // Function to filter the category tree
    const filterCategoryTree = (category) => {
      if (category.category_code === config.categoryCode) {
        return true;
      }
      category.child_categories = category.child_categories.filter(filterCategoryTree);
      return category.child_categories.length > 0;
    };
  
    // Filter rootCategories if config.categoryCode is provided
    let rootCategories = rootCategoryIds.map(id => detailedCategoryMap[id]);
    if (config.categoryCode) {
      rootCategories = rootCategories.filter(filterCategoryTree);
    }
  
    // Add level property to each category after filtering
    const addLevels = (category, level = 1) => {
      category.level = level;
      category.child_categories.forEach(childCategory => addLevels(childCategory, level + 1));
    };
    rootCategories.forEach(rootCategory => addLevels(rootCategory));
  
    // Calculate the maximum depth of the category tree
    let maxDepth = 1;
    const calculateMaxDepth = (category) => {
      if (category.level > maxDepth) {
        maxDepth = category.level;
      }
      category.child_categories.forEach(calculateMaxDepth);
    };
    rootCategories.forEach(calculateMaxDepth);
  
    const renderCategoryRows = (category) => {
      if (category.level === 2) {
        return (
          <>
            <tr key={category.id}>
              <td>
                <a href={`${config.siteUrl}/category/${category.category_code}`}>
                  {category.name}
                </a>
              </td>
            </tr>
            <tr key={category.id}>
              <td>
                {category.child_categories.length > 0 && (
                  <table>
                    <tbody>
                      <tr>
                        {category.child_categories.map(childCategory => renderCategoryRows(childCategory))}
                      </tr>
                    </tbody>
                  </table>
                )}
              </td>
            </tr>
            {/* Add empty cells to match max depth */}
            
          </>
        );
      } else {
        return (
          <React.Fragment key={category.id}>
            <td>
              <a href={`${config.siteUrl}/category/${category.category_code}`}>
                {category.name}
              </a>
              {category.child_categories.length > 0 && (
                <table>
                  <tbody>
                    {category.level === 1 && (
                      <>
                        {category.child_categories.map(childCategory => renderCategoryRows(childCategory))}
                        {Array.from({ length: maxDepth - category.level }, (_, index) => (
                          // <tr key={`empty-${category.id}-${index}`} >
                          //   <td>Emptty</td>
                          // </tr>
                          <tr key={`empty-${category.id}-${index}`} />
                        ))}
                      </>
                    )}
                    {category.level !== 1 && (
                      <>
                        <tr>
                          {category.child_categories.map(childCategory => renderCategoryRows(childCategory))}
                        </tr>
                        {/* Add empty cells to match max depth */}
                        {Array.from({ length: maxDepth - category.level }, (_, index) => (
                          <tr key={`empty-${category.id}-${index}`} />
                        ))}
                      </>
                    )}
                  </tbody>
                </table>
              )}
            </td>
            
          </React.Fragment>
        );
      }
    };
  
    return (
      <div>
          <table className="all_category category-table">
            <tbody>
              <tr>
                <td colSpan={8}>
                  Our Offering
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr>
                {rootCategories.map(rootCategory => (
                  <>
                    {renderCategoryRows(rootCategory)}
                  </>
                ))}
              </tr>
            </tbody>
          </table>
      </div>
    );
  };
  

  return (
    <div className="child-categories">
      {config.showViewTogle && (
        <div className="layout-switcher" style={{ textAlign: 'right', marginBottom: '10px' }}>
          <FontAwesomeIcon
            icon={faGlobe}
            style={{ cursor: 'pointer', marginRight: '10px' }}
            onClick={() => setLayout('all')}
          />
          <FontAwesomeIcon
            icon={faTable}
            style={{ cursor: 'pointer', marginRight: '10px' }}
            onClick={() => setLayout('table')}
          />
          <FontAwesomeIcon
            icon={faTh}
            style={{ cursor: 'pointer', marginRight: '10px' }}
            onClick={() => setLayout('grid')}
          />
          <FontAwesomeIcon
            icon={faListUl}
            style={{ cursor: 'pointer', marginRight: '10px' }}
            onClick={() => setLayout('tree')}
          />
          <FontAwesomeIcon
            icon={faTags}
            style={{ cursor: 'pointer' }}
            onClick={() => setLayout('tags')}
          />
        </div>
      )}

      {layout === 'all' && (
        <div>
          <section id="mm_related_cat_section">
            <div className="elementor-container elementor-column-gap-extended" style={{ maxWidth: '1200px', margin: 'auto' }}>
              {renderCategories(childCategories, config)}
            </div>
          </section>
        </div>
      )}
      {layout === 'table' && (
        <table className="sub-category-block wp-list-table widefat striped alternate-color">
          <thead>
            <tr>
              <th>Related Categories</th>
              {/* <th></th> */}
            </tr>
          </thead>
          <tbody>
            {categoriesToShow.map((childCategory) => (
              <tr key={childCategory.category_code}>
                {/* <td>
                  <img
                    style={{ maxWidth: '40px' }}
                    src={childCategory.icon || 'https://placehold.co/40x40'}
                    alt={childCategory.name || ''}
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = 'https://placehold.co/40x40';
                    }}
                  />
                </td> */}
                {/* <td>{childCategory.category_name || ''}</td> */}
                {/* <td>{childCategory.title || ''}</td> */}
                <td>
                  {childCategory.custom_url && 
                    <a href={`${childCategory.custom_url}`}>
                      {childCategory.title || ''}
                    </a>
                  }
                  {!childCategory.custom_url && 
                    <a href={`${config.siteUrl}/category/${childCategory.category_code}`}>
                      {childCategory.title || ''}
                    </a>
                  }
                  {/* <a href={`${config.siteUrl}/category/${childCategory.category_code}`}>
                    View Details
                  </a> */}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {layout === 'tree' && 
        
        // <CategoryTree categories={hierarchicalCategories} />
        <CategoryTree categories={hierarchicalCategories} />
      }
      {/* {layout === 'grid' && (
        <div className="child-categories-grid">
          {categoriesToShow.map((childCategory) => (
            <div key={childCategory.category_code} className="child-category-item">
              <img
                style={{ maxWidth: '100px' }}
                src={childCategory.icon || 'https://placehold.co/100x100'}
                alt={childCategory.name || ''}
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null;
                  currentTarget.src = 'https://placehold.co/100x100';
                }}
              />
              <h3>{childCategory.category_name || ''}</h3>
              <p>{childCategory.title || ''}</p>
              <a href={`${config.siteUrl}/category/${childCategory.category_code}`}>
                View Details
              </a>
            </div>
          ))}
        </div>
      )} */}
            {layout === 'grid' && (
        <div className="grid-layout">
          <div className="elementor-container elementor-column-gap-default">
            <div className="elementor-row">
              {categoriesToShow.map((childCategory) => (
                <div key={childCategory.category_code} className={`${colWidthClass} elementor-column elementor-inner-column category-item`}>
                  <div className="elementor-column-wrap elementor-element-populated">
                    <div className="elementor-widget-wrap">
                      <div className="elementor-widget elementor-widget-image-box">
                        <div className="elementor-widget-container">
                          <div className="elementor-image-box-wrapper">
                            <img
                              style={{ width: '100%' }}
                              src={childCategory.thumbnail || 'https://placehold.co/292x171'}
                              alt={childCategory.category_name || ''}
                              className="category-banner"
                            />
                            <div className="elementor-image-box-content">
                              <h3 className="elementor-image-box-title">
                                <a href={`${config.siteUrl}/category/${childCategory.category_code}`}>
                                  {childCategory.category_name || ''}
                                </a>
                              </h3>
                              <div className="elementor-image-box-description" style={{ height: '465px', overflow: 'hidden' }}>
                                <p dangerouslySetInnerHTML={{ __html: childCategory.short_description || '' }} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="elementor-widget elementor-widget-ct_button">
                        <div className="elementor-widget-container">
                          <div className="ct-button-wrapper ct-button-layout1 icon- btn--inline">
                            <a href={`${config.siteUrl}/category/${childCategory.category_code}`} className="btn btn-default icon-active btn-inline-block">
                              <span className="ct-button-text">Read More</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
      {/* {layout === 'tags' && (
        <div className="tag-cloud">
          {categoriesToShow.map((childCategory) => (
            <a key={childCategory.category_code} href={`${config.siteUrl}/category/${childCategory.category_code}`} className="tag-cloud-link">
              {childCategory.category_name || ''}
            </a>
          ))}
        </div>
      )} */}
      {layout === 'tags' && (
        <div className="tags-layout">
          {categoriesToShow.map((childCategory) => (
            <div key={childCategory.category_code} className="badge badge-primary tag">
              <a href={`${config.siteUrl}/category/${childCategory.category_code}`}>
                {childCategory.category_name || ''}
              </a>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CategoryBlock;
